import React, {FC, useEffect, useState} from "react";
import Typography from "@material-ui/core/Typography";
import {Button, Card, CardActions, CardContent, Grid, makeStyles, MenuItem, Select,FormControl} from "@material-ui/core";
import {IAssessment, IFailureMode, IProjectFailureMode, IRiskAssessment} from "../types/types";

import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';

interface IFailureModeProps {
    failure_modes:IProjectFailureMode[],
    risk_assessment: IRiskAssessment,
    updateRiskAssessment: (risk_assessment: IRiskAssessment) => void,
    initial_selection_id: string
}



const useStyles = makeStyles((theme) => ({
    button: {
        display: 'block',
        marginTop: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
        maxWidth: 250,
        whiteSpace: "normal",
    },
    menu:{
        width: 250,
    },
    listItem: {
        whiteSpace: "normal",
    }
}));

const FailureModesSelect: FC<IFailureModeProps> = ({failure_modes, risk_assessment, updateRiskAssessment, initial_selection_id}: IFailureModeProps) => {

    useEffect(() => {
        if (selected === initial_selection_id) {
            return
        }
        setSelected(initial_selection_id)

    }, [initial_selection_id])

    let tasks = useTask()

    const [selected, setSelected] = useState(initial_selection_id);
    const [write_access, setWriteAccess] = useState<boolean>(false);

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])

    const classes = useStyles();

    return (
        <div>

            <FormControl className={classes.formControl}>
            <Select
                value={selected}
                style={{fontSize:"11pt"}}
                disabled={!write_access}
                onChange={(event) => {
                    let selection = event.target.value
                    let selected_id = failure_modes.find( (f) => f.id === selection)
                        if (selected_id) {
                            if(selected_id.id) {
                                risk_assessment.project_failure_mode_id = selected_id.id;
                                let r = {annual_failure_probability: risk_assessment.annual_failure_probability,
                                    description: risk_assessment.description,
                                    failure_mode: risk_assessment.failure_mode,
                                    individual_risk: risk_assessment.individual_risk,
                                    project_failure_mode_id: risk_assessment.project_failure_mode_id,
                                    societal_risk: risk_assessment.societal_risk,
                                    document_id: risk_assessment.document_id,
                                    uuid: risk_assessment.uuid}
                                updateRiskAssessment(r)
                            }
                        }
                    setSelected(event.target.value as string)
                }
                } >
                {failure_modes.filter( (f) => f.failure_mode?.is_active).map((d) => {

                    return <MenuItem value={d.id}>{d.failure_mode?.name}</MenuItem>
                })}
            </Select>
            </FormControl>
        </div>
    );
}

export default FailureModesSelect;
